import React from 'react';
import Styles from './module-certificate-des-approved-styles.scss';
import classNames from 'classnames';
import NoCongratzCertificateIcon from '@/presentation/components/icons/no-congratz-certificate-icon';
const ModuleCertificateDesApproved = ({ grade, onOpenCertificate, onClick }) => {
    return (React.createElement("div", { className: classNames([Styles.moduleItemWrap]) },
        React.createElement("div", { className: Styles.content },
            React.createElement(NoCongratzCertificateIcon, null),
            React.createElement("div", { className: Styles.title }, "Certificate of Completion"),
            React.createElement("div", { className: Styles.subTitle }, "Complete all modules to get a Certificate of Completion"))));
};
export default ModuleCertificateDesApproved;
